import React, { useEffect } from 'react';
import { DATE_TIME_TYPE, DateTimeFormat } from '@cp/components/DateTimePicker/constants';
import dayjs from 'dayjs';

interface DateTimePickerLabelProps {
  date: string;
  type: DATE_TIME_TYPE;
  id?: string;
}

const DateTimePickerLabel = ({ date, type, id }: DateTimePickerLabelProps) => {
  const [label, setLabel] = React.useState<string>('');
  useEffect(() => {
    if (date && date === 'StartDate') {
      setLabel('Start Date');
    } else if (date && date !== 'SelectDate') {
      switch (type) {
        case DATE_TIME_TYPE.DATE:
          setLabel(dayjs(date).format(DateTimeFormat.DATE_ONLY));
          break;
        case DATE_TIME_TYPE.TIME:
          setLabel(dayjs(`1970-01-01T${date}:00`, 'HH:mm').format(DateTimeFormat.TIME_ONLY));
          break;
        case DATE_TIME_TYPE.DATE_TIME:
          setLabel(dayjs(date).format(DateTimeFormat.DATE_TIME));
          break;
        default:
          setLabel(dayjs(date).format(DateTimeFormat.DATE_ONLY));
          break;
      }
    } else {
      setLabel(`Select ${DATE_TIME_TYPE.TIME === type ? 'Time' : 'Date'}`);
    }
  }, [date, type]);

  return <label htmlFor={id}>{label}</label>;
};

export default DateTimePickerLabel;
